export default {
  // patient
  unitType: 'unitType',
  uf: 'uf',
  sheetNumber: 'sheetNumber',
  birthdate: 'birthdate',
  sex: 'sex',
  entrydate: 'entry',
  immuno: 'immuno',
  cancer: 'cancer',
  cribII: 'cribII',
  pimII: 'pimII',
  igsII: 'igsII',
  mixManagment: 'mixManagment',
  expManagment: 'expManagment',
  patientOrigin: 'patientOrigin',
  origin: 'origin',
  neoOrigin: 'neoOrigin',
  birthWeight: 'birthWeight',
  gestationalAge: 'gestationalAge',
  dead: 'dead',
  future: 'future',
  death: 'death',
  exit: 'exit',
  trauma: 'trauma',
  antibio: 'antibio',
  diagnosis: 'diagnosis',
  severityType: 'severityType',
  severityScore: 'severityScore',
  mainSeverity: 'mainSeverity',
  otherSeverity: 'otherSeverity',
  bmi: 'bmi',

  // catheter
  catheterArray: 'catheters',
  central: 'central',
  catheterType: 'type',
  otherCatheterType: 'otherCatheterType',
  laboratory: 'laboratory',
  removed: 'removed',
  removal: 'removal',
  present: 'present',

  // bacteremia
  bactArray: 'bacteremias',
  episod: 'episod',
  diagDate: 'diagDate',
  entrance: 'entrance',
  microOrg: 'microOrg',
  microOrganisms: 'microOrganisms',
  microOrgCode: 'code',
  microOrgDetail: 'microOrgDetail',
  bacteremia: 'bacteremia',
  episodImmuno: 'episodImmuno',
  insertion: 'insertion',
  previousManip: 'previousManip',
  previousManipType: 'previousManipType',
  previousManipDate: 'previousManipDate',
  insertionSite: 'insertionSite',
  bactOrigin: 'bactOrigin',
  enfCatheter: 'catheter',
  enfCatheterType: 'catheterType',
  enfInsertionDate: 'catheterInsertion',
  enfPreviousManip: 'enfPreviousManip',
  enfPreviousManipType: 'enfPreviousManipType',
  enfPreviousManipDate: 'enfPreviousManipDate',
  divDiag: 'divDiag',
  clinicalSigns: 'clinicalSigns',
  bioSigns: 'bioSigns',
  adaptedAntibio: 'adaptedAntibio',
  twoHemocs: 'twoHemocs',
  neoDivDiag: 'neoDivDiag',
  lipids: 'lipids',
  enfTunneled: 'enfTunneled',
  covidStatus: 'covidStatus',
  explaurID: 'explaurID',

  // resistances
  oxa: 'oxa',
  gly: 'gly',
  pan: 'pan',
  rktg: 'rktg',
  c3g: 'c3g',
  blse: 'blse',
  car: 'car',
  epc: 'epc',
  epcType: 'epcType',
  epcType2: 'epcType2',
  caz: 'caz',
  ppc: 'ppc',
  ppcType: 'ppcType',
  ppcType2: 'ppcType2',
  flu: 'flu',

  // dialysis
  accessSite: 'accessSite',
  ablated: 'ablated',
  useEnded: 'useEnded',
  hemodiafiltr: 'hemodiafiltr',
  treatedDiab: 'treatedDiab',
  hygiene: 'hygiene',
  previousInfect: 'previousInfect',
  previousBact: 'previousBact',
  toxico: 'toxico',
  vih: 'vih',
  vhc: 'vhc',
  height: 'height',
  weight: 'weight',
  ferritinaemia: 'ferritinaemia',
  saturation: 'saturation',
  hemoglobin: 'hemoglobin',
  albumin: 'albumin',
  creatinine: 'creatinine',
  dialNumber: 'dialNumber',
  cardioVascPb: 'cardioVascPb',
  surgery: 'surgery',
  transfusions: 'transfusions',
  exitReason: 'exitReason',
  uses: 'uses',
  incidents: 'incidents',
  unrelatedManip: 'unrelatedManip',
  installReason: 'installReason',
  tunneled: 'tunneled',
  installSite: 'installSite',
  siteChanges: 'siteChanges',
  antibiopr: 'antibiopr',
  firstSubstn: 'firstSubstn',
  infection: 'infection',
  heparine: 'heparine',
  citrate: 'citrate',
  serumPhy: 'serumPhy',
  taurine: 'taurine',
  alcohol: 'alcohol',
  other: 'other',
  cap: 'cap',
  firstUse: 'firstUse',
  ablation: 'ablation',
  useEnding: 'useEnding',
  infections: 'infections',
  date: 'date',
  lock: 'lock',
  installLock: 'installLock',
  disconnectLock: 'disconnectLock',

  // neo
  material: 'material',
  removalReason: 'removalReason',
  neoColIlcBlcSep: 'neoColIlcBlcSep',
  colIlcBlcSepOrigin: 'colIlcBlcSepOrigin',
  neoInfOrigin: 'neoInfOrigin',
  lipidsDiagnosis: 'lipidsDiagnosis',
  blcCriteria: 'blcCriteria',
  birthSite: 'birthSite',
  leucomalacy: 'leucomalacy',
  colIlcBlcSep: 'colIlcBlcSep',
  isColIlcBlcSep: 'isColIlcBlcSep',
  sepsis: 'sepsis',

  // ventilation
  ventilation: 'ventilation',
  intubated: 'intubated',
  reintubated: 'reintubated',
  intubStart: 'intubStart',
  intubEnd: 'intubEnd',

  // urinary
  urinary: 'urinary',
  urinaryStart: 'urinaryStart',
  urinaryRemoved: 'urinaryRemoved',
  urinaryEnd: 'urinaryEnd',
  urinaryDiag: 'urinaryDiag',

  // reaInfADI
  ecmo: 'ecmo',
  portageBmrBhre: 'portageBmrBhre',
  bmrBhreMicroOrg: 'bmrBhreMicroOrg',
  bmrBhreMicroOrgs: 'bmrBhreMicroOrgs',
  colIlcBlc: 'colIlcBlc',
  isColIlcBlc: 'isColIlcBlc',
  pneumopathies: 'pneumopathies',
  pneumopathy: 'pneumopathy',

  obsManagment: 'obsManagment',
  isEhpad: 'isEhpad',
  obsDate: 'obsDate',
  place: 'place',
  otherPlace: 'otherPlace',
  manipType: 'manipType',
  otherManipType: 'otherManipType',
  secondManipType: 'secondManipType',
  secondOtherManipType: 'secondOtherManipType',
  firstDressing: 'firstDressing',
  insertionDate: 'insertionDate',
  lastDressingDate: 'lastDressingDate',
  audited: 'audited',
  auditedDetail: 'auditedDetail',
  student: 'student',
  sterileGown: 'sterileGown',
  auditedCleanOutfit: 'auditedCleanOutfit',
  auditedCleanOutfitOrProt: 'auditedCleanOutfitOrProt',
  auditedCap: 'auditedCap',
  compliantAuditedCap: 'compliantAuditedCap',
  auditedMask: 'auditedMask',
  compliantAuditedMask: 'compliantAuditedMask',
  isAdult: 'isAdult',
  childAge: 'childAge',
  patientCleanOutfit: 'patientCleanOutfit',
  patientMask: 'patientMask',
  compliantPatientMask: 'compliantPatientMask',
  patientSterileField: 'patientSterileField',
  patientHeadSterileField: 'patientHeadSterileField',
  patientOtherSide: 'patientOtherSide',
  patientCap: 'patientCap',
  compliantPatientCap: 'compliantPatientCap',
  dirtySkin: 'dirtySkin',
  insertionSiteCleaned: 'insertionSiteCleaned',
  auditedCleanSkin: 'auditedCleanSkin',
  soap: 'soap',
  soapOther: 'soapOther',
  rinsingAfterCatheterInsertion: 'rinsingAfterCatheterInsertion',
  insertionGlovesKeptForRinsing: 'insertionGlovesKeptForRinsing',
  syringeCapacity: 'syringeCapacity',
  syringeCapacityOther: 'syringeCapacityOther',
  injectedRinsingVolume: 'injectedRinsingVolume',
  injectedRinsingSolution: 'injectedRinsingSolution',
  injectedRinsingSolutionOther: 'injectedRinsingSolutionOther',
  readyPreFilledSyringe: 'readyPreFilledSyringe',
  singleDoseRinsingSolution: 'singleDoseRinsingSolution',
  syringePreparedJustBeforeRinsing: 'syringePreparedJustBeforeRinsing',
  rinsingBySuccessivePushes: 'rinsingBySuccessivePushes',
  rinsingSuccessivePushesCount: 'rinsingSuccessivePushesCount',
  syringeEliminatedImmediatelyAfterRinsing: 'syringeEliminatedImmediatelyAfterRinsing',
  solutionContainerEliminatedImmediatelyAfterRinsing: 'solutionContainerEliminatedImmediatelyAfterRinsing',
  deviceUsage: 'deviceUsage',
  isolatedRinsingReason: 'isolatedRinsingReason',
  isolatedRinsingReasonDetail: 'isolatedRinsingReasonDetail',
  rinsingBeforeManipulation: 'rinsingBeforeManipulation',
  rinsingAfterManipulation: 'rinsingAfterManipulation',
  rinsing: 'rincing', // too late to change :(
  dryingWithSterileCompresses: 'dryingWithSterileCompresses',
  antisepticApplied: 'antisepticApplied',
  antiseptic: 'antiseptic',
  otherAntiseptic: 'otherAntiseptic',
  sterileCompresses: 'sterileCompresses',
  compressesType: 'compressesType',
  useCompresses: 'useCompresses',
  auditedApplyASQ: 'auditedApplyASQ',
  antisepticPassages: 'antisepticPassages',
  dry: 'dry',
  injectedProduct: 'injectedProduct',
  injectedProductDetail: 'injectedProductDetail',
  fistula: 'fistula',
  buttonHole: 'buttonHole',
  auditedOvercoat: 'auditedOvercoat',
  auditedEyeProtection: 'auditedEyeProtection',
  insertionSiteCleanedByPatient: 'insertionSiteCleanedByPatient',
  rinsingProduct: 'rinsingProduct',
  dryingEquipment: 'dryingEquipment',
  handHygiene: 'handHygiene',
  handHygieneType: 'handHygieneType',
  handHygieneCompliant: 'handHygieneCompliant',
  secondaryHandHygiene: 'secondaryHandHygiene',
  secondaryHandHygieneType: 'secondaryHandHygieneType',
  secondaryHandHygieneCompliant: 'secondaryHandHygieneCompliant',
  thirdHandHygiene: 'thirdHandHygiene',
  thirdHandHygieneType: 'thirdHandHygieneType',
  thirdHandHygieneCompliant: 'thirdHandHygieneCompliant',
  fourthHandHygiene: 'fourthHandHygiene',
  fourthHandHygieneType: 'fourthHandHygieneType',
  fourthHandHygieneCompliant: 'fourthHandHygieneCompliant',
  fifthHandHygiene: 'fifthHandHygiene',
  fifthHandHygieneType: 'fifthHandHygieneType',
  fifthHandHygieneCompliant: 'fifthHandHygieneCompliant',
  handHygieneBeforeInsertion: 'handHygieneBeforeInsertion',
  handHygieneBeforeInsertionType: 'handHygieneBeforeInsertionType',
  handHygieneBeforeInsertionCompliant: 'handHygieneBeforeInsertionCompliant',
  handHygieneBeforePeriInsertion: 'handHygieneBeforePeriInsertion',
  handHygieneBeforePeriInsertionType: 'handHygieneBeforePeriInsertionType',
  handHygieneBeforePeriInsertionCompliant: 'handHygieneBeforePeriInsertionCompliant',
  handHygieneBeforePreparation: 'handHygieneBeforePreparation',
  handHygieneBeforePreparationType: 'handHygieneBeforePreparationType',
  handHygieneBeforePreparationCompliant: 'handHygieneBeforePreparationCompliant',
  handHygieneBeforePuncture: 'handHygieneBeforePuncture',
  handHygieneBeforePunctureType: 'handHygieneBeforePunctureType',
  handHygieneBeforePunctureCompliant: 'handHygieneBeforePunctureCompliant',
  handHygieneBeforeManip: 'handHygieneBeforeManip',
  handHygieneBeforeManipType: 'handHygieneBeforeManipType',
  handHygieneBeforeManipCompliant: 'handHygieneBeforeManipCompliant',
  handHygieneBeforeGloves: 'handHygieneBeforeGloves',
  handHygieneBeforeGlovesType: 'handHygieneBeforeGlovesType',
  handHygieneBeforeGlovesCompliant: 'handHygieneBeforeGlovesCompliant',
  handHygieneBeforeEquipmentPreparation: 'handHygieneBeforeEquipmentPreparation',
  handHygieneBeforeEquipmentPreparationType: 'handHygieneBeforeEquipmentPreparationType',
  handHygieneBeforeEquipmentPreparationCompliant: 'handHygieneBeforeEquipmentPreparationCompliant',
  handHygieneBeforeB2Manip: 'handHygieneBeforeB2Manip',
  handHygieneBeforeB2ManipType: 'handHygieneBeforeB2ManipType',
  handHygieneBeforeB2ManipCompliant: 'handHygieneBeforeB2ManipCompliant',
  handHygieneAfterR1Gloves: 'handHygieneAfterR1Gloves',
  handHygieneAfterR1GlovesType: 'handHygieneAfterR1GlovesType',
  handHygieneAfterR1GlovesCompliant: 'handHygieneAfterR1GlovesCompliant',
  handHygieneAfterR1StabilizerGloves: 'handHygieneAfterR1StabilizerGloves',
  handHygieneAfterR1StabilizerGlovesType: 'handHygieneAfterR1StabilizerGlovesType',
  handHygieneAfterR1StabilizerGlovesCompliant: 'handHygieneAfterR1StabilizerGlovesCompliant',
  handHygieneAfterR1RepairGloves: 'handHygieneAfterR1RepairGloves',
  handHygieneAfterR1RepairGlovesType: 'handHygieneAfterR1RepairGlovesType',
  handHygieneAfterR1RepairGlovesCompliant: 'handHygieneAfterR1RepairGlovesCompliant',
  handHygieneAfterR1ImplementationGloves: 'handHygieneAfterR1ImplementationGloves',
  handHygieneAfterR1ImplementationGlovesType: 'handHygieneAfterR1ImplementationGlovesType',
  handHygieneAfterR1ImplementationGlovesCompliant: 'handHygieneAfterR1ImplementationGlovesCompliant',
  handHygieneBeforeP1UltrasoundPreparation: 'handHygieneBeforeP1UltrasoundPreparation',
  handHygieneBeforeP1UltrasoundPreparationType: 'handHygieneBeforeP1UltrasoundPreparationType',
  handHygieneBeforeP1UltrasoundPreparationCompliant: 'handHygieneBeforeP1UltrasoundPreparationCompliant',
  handHygieneBeforeP1UltrasoundSearch: 'handHygieneBeforeP1UltrasoundSearch',
  handHygieneBeforeP1UltrasoundSearchType: 'handHygieneBeforeP1UltrasoundSearchType',
  handHygieneBeforeP1UltrasoundSearchCompliant: 'handHygieneBeforeP1UltrasoundSearchCompliant',
  handHygieneBeforeP1SkinCleaning: 'handHygieneBeforeP1SkinCleaning',
  handHygieneBeforeP1SkinCleaningType: 'handHygieneBeforeP1SkinCleaningType',
  handHygieneBeforeP1SkinCleaningCompliant: 'handHygieneBeforeP1SkinCleaningCompliant',
  handHygieneBeforeP1Antiseptic: 'handHygieneBeforeP1Antiseptic',
  handHygieneBeforeP1AntisepticType: 'handHygieneBeforeP1AntisepticType',
  handHygieneBeforeP1AntisepticCompliant: 'handHygieneBeforeP1AntisepticCompliant',
  holdTissue: 'holdTissue',
  sterileGloves: 'sterileGloves',
  gloves: 'gloves',
  glovesPutOn: 'glovesPutOn',
  glovesPutOnManip: 'glovesPutOnManip',
  glovesType: 'glovesType',
  secondaryGloves: 'secondaryGloves',
  secondaryGlovesType: 'secondaryGlovesType',
  thirdGloves: 'thirdGloves',
  thirdGlovesType: 'thirdGlovesType',
  thirdGlovesRemoval: 'thirdGlovesRemoval',
  fourthGloves: 'fourthGloves',
  fourthGlovesType: 'fourthGlovesType',
  fourthGlovesRemoval: 'fourthGlovesRemoval',
  glovesJustified: 'glovesJustified',
  glovesNecessary: 'glovesNecessary',
  valve: 'valve',
  valveAntisepticApplied: 'valveAntisepticApplied',
  valveAntiseptic: 'valveAntiseptic',
  valveAntisepticOther: 'valveAntisepticOther',
  valveAntisepticCompliant: 'valveAntisepticCompliant',
  palpation: 'palpation',
  preFencedSterileField: 'preFencedSterileField',
  strippingSufficient: 'strippingSufficient',
  scheduledDressingRepair: 'scheduledDressingRepair',
  soiledDressing: 'soiledDressing',
  dressingPeelsOff: 'dressingPeelsOff',
  dressingWithCompresses: 'dressingWithCompresses',
  sterileSemiPermeableTransparent: 'sterileSemiPermeableTransparent',
  sterilePreparation: 'sterilePreparation',
  removeDressingByStretching: 'removeDressingByStretching',
  signsOfSkinIrritation: 'signsOfSkinIrritation',
  hasStabilizer: 'hasStabilizer',
  glovesRemoval: 'glovesRemoval',
  secondaryGlovesRemoval: 'secondaryGlovesRemoval',
  changeStabilizer: 'changeStabilizer',
  changeStabilizerReason: 'changeStabilizerReason',
  dressingSet: 'dressingSet',
  newStabilizer: 'newStabilizer',
  antiPeelingProduct: 'antiPeelingProduct',
  newDressingWithCompresses: 'newDressingWithCompresses',
  newDressingSterileSemiPermeableTransparent: 'newDressingSterileSemiPermeableTransparent',
  newDressingImpregnated: 'newDressingImpregnated',
  chpSwabbing: 'chpSwabbing',
  chpSwabNumber: 'chpSwabNumber',
  withUltrasound: 'withUltrasound',
  ultrasoundPrepared: 'ultrasoundPrepared',
  usAuditedPreparation: 'usAuditedPreparation',
  ultrasoundWiping: 'ultrasoundWiping',
  usAuditedSearch: 'usAuditedSearch',
  gelUsed: 'gelUsed',
  secondGelUsed: 'secondGelUsed',
  gelApplied: 'gelApplied',
  vialOpeningDateWritten: 'vialOpeningDateWritten',
  vialOpenedSince: 'vialOpenedSince',
  ultrasoundSheath: 'ultrasoundSheath',
  secondUltrasoundSheath: 'secondUltrasoundSheath',
  sheathRemoval: 'sheathRemoval',
  probeCovered: 'probeCovered',
  sheathJustBeforeInsertion: 'sheathJustBeforeInsertion',
  nakedEyeSheathInspection: 'nakedEyeSheathInspection',
  probeNeedleContact: 'probeNeedleContact',
  auditedTouchProbe: 'auditedTouchProbe',
  probeTouchedWith: 'probeTouchedWith',
  probeInspection: 'probeInspection',
  tearedSheath: 'tearedSheath',
  dirtyProbe: 'dirtyProbe',
  probeCleaned: 'probeCleaned',
  probeCleaningMethod: 'probeCleaningMethod',
  probeCleaningProduct: 'probeCleaningProduct',
  insertionSiteDetail: 'insertionSiteDetail',
  withHelp: 'withHelp',

  whyNotHHC: 'whyNotHHC',
  whyNotHHCDetail: 'whyNotHHCDetail',
  whyNotHH: 'whyNotHH',
  whyNotHHDetail: 'whyNotHHDetail',
  whyNotP2HH: 'whyNotP2HH',
  whyNotP2HHDetail: 'whyNotP2HHDetail',
  whyNotHHP: 'whyNotHHP',
  whyNotHHPDetail: 'whyNotHHPDetail',
  whyNotHHM: 'whyNotHHM',
  whyNotHHMDetail: 'whyNotHHMDetail',
  whyNotHHCompliant: 'whyNotHHCompliant',
  whyNotHHCompliantDetail: 'whyNotHHCompliantDetail',

  whyNotHHCompliantPrerequisitesNotCompliant: 'whyNotHHCompliantPrerequisitesNotCompliant',
  whyNotHHCompliantMissingStep: 'whyNotHHCompliantMissingStep',
  whyNotHHCompliantNotLongEnough: 'whyNotHHCompliantNotLongEnough',
  whyNotHHCompliantNotEnoughGel: 'whyNotHHCompliantNotEnoughGel',

  whyNotHHAfterDressingRemoval: 'whyNotHHAfterDressingRemoval',
  whyNotHHAfterDressingRemovalDetail: 'whyNotHHAfterDressingRemovalDetail',
  whyNotGROnStabilizerChange: 'whyNotGROnStabilizerChange',
  whyNotGROnStabilizerChangeDetail: 'whyNotGROnStabilizerChangeDetail',
  whyNotHHAfterStabilizerGR: 'whyNotHHAfterStabilizerGR',
  whyNotHHAfterStabilizerGRDetail: 'whyNotHHAfterStabilizerGRDetail',
  whyNotGloves: 'whyNotGloves',
  whyNotGlovesDetail: 'whyNotGlovesDetail',
  whyNotSterileGloves: 'whyNotSterileGloves',
  whyNotSterileGlovesDetail: 'whyNotSterileGlovesDetail',
  whyNotSGForAntisepsis: 'whyNotSGForAntisepsis',
  whyNotSGForAntisepsisDetail: 'whyNotSGForAntisepsisDetail',
  whyNotAlcool: 'whyNotAlcool',
  whyNotAlcoolDetail: 'whyNotAlcoolDetail',
  whyNCAuditedOutfit: 'whyNCAuditedOutfit',
  whyNCAuditedOutfitDetail: 'whyNCAuditedOutfitDetail',
  whyNCPatientOutfit: 'whyNCPatientOutfit',
  whyNCPatientOutfitDetail: 'whyNCPatientOutfitDetail',
  whyNotSterileCompresses: 'whyNotSterileCompresses',
  whyNotSterileCompressesDetail: 'whyNotSterileCompressesDetail',
  whyNotCompresses: 'whyNotCompresses',
  whyNotCompressesDetail: 'whyNotCompressesDetail',
  whyNotDisinfectValve: 'whyNotDisinfectValve',
  whyNotDisinfectValveDetail: 'whyNotDisinfectValveDetail',
  whyNotAuditedMask: 'whyNotAuditedMask',
  whyNotAuditedMaskDetail: 'whyNotAuditedMaskDetail',
  whySheathNotRemovedAfterSearch: 'whySheathNotRemovedAfterSearch',
  whySheathNotRemovedAfterSearchDetail: 'whySheathNotRemovedAfterSearchDetail',
  whyNotRemoveGlovesAfterTouch: 'whyNotRemoveGlovesAfterTouch',
  whyNotRemoveGlovesAfterTouchDetail: 'whyNotRemoveGlovesAfterTouchDetail',
  whyNotChlAlc2Percent: 'whyNotChlAlc2Percent',
  whyNotChlAlc2PercentDetail: 'whyNotChlAlc2PercentDetail',
  whyNotSGForPalpation: 'whyNotSGForPalpation',
  whyNotSGForPalpationDetail: 'whyNotSGForPalpationDetail',
  whyNotHHBeforeGloves: 'whyNotHHBeforeGloves',
  whyNotHHBeforeGlovesDetail: 'whyNotHHBeforeGlovesDetail',
  whyNotHHBeforeAntisepsis: 'whyNotHHBeforeAntisepsis',
  whyNotHHBeforeAntisepsisDetail: 'whyNotHHBeforeAntisepsisDetail',
  whyNotRinsingDoneAfterCatheterInsertion: 'whyNotRinsingDoneAfterCatheterInsertion',
  whyNotRinsingDoneAfterCatheterInsertionDetail: 'whyNotRinsingDoneAfterCatheterInsertionDetail',
  whyNotRinsingDoneWhenManipulating: 'whyNotRinsingDoneWhenManipulating',
  whyNotRinsingDoneWhenManipulatingDetail: 'whyNotRinsingDoneWhenManipulatingDetail',
  whyNotSurgicalHandrubbing: 'whyNotSurgicalHandrubbing',
  whyNotSurgicalHandrubbingDetail: 'whyNotSurgicalHandrubbingDetail',
  whyNotSGForInsertion: 'whyNotSGForInsertion',
  whyNotSGForInsertionDetail: 'whyNotSGForInsertionDetail'
}
